import { Link, useT } from '../../lib/i18n';
import { usePages } from '../../lib/pages';
import { useSettings } from '../../lib/settings';
import { LanguageSwitch, useTaxonomy } from './Header';

export function Footer() {
  const { store } = useSettings();
  const t = useT();
  const { categories, collections } = useTaxonomy();
  const { pages } = usePages();
  const year = new Date().getFullYear();
  const heading = 'typewriter mb-5 text-[11.5px] font-bold tracking-[0.2em] text-paper/50 uppercase';
  const item = 'link-underline hover:text-paper';

  return (
    <footer className="bg-night text-paper">
      <div className="h-2 bg-[repeating-linear-gradient(90deg,var(--color-accent)_0_28px,var(--color-paper)_28px_56px)] opacity-80" aria-hidden />
      <div className="container-page grid gap-14 pt-16 pb-12 md:grid-cols-12 md:gap-10 md:pt-20">
        <div className="md:col-span-5">
          <p className="font-display text-[2.4rem] leading-none font-semibold">{store.name}</p>
          <p className="typewriter mt-3 text-[11px] tracking-[0.28em] text-paper/50 uppercase">{t.est}</p>
          <p className="mt-5 max-w-sm text-[17px] leading-relaxed text-paper/70">{store.tagline}</p>
        </div>
        <nav className="grid grid-cols-2 gap-10 sm:grid-cols-3 md:col-span-7" aria-label={t.footer.footer}>
          <div>
            <p className={heading}>{t.footer.shop}</p>
            <ul className="space-y-3 text-[16.5px] text-paper/80">
              <li>
                <Link to="/" className={item}>
                  {t.common.shopAll}
                </Link>
              </li>
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/categories/${c.slug}`} className={item}>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className={heading}>{t.footer.collections}</p>
            <ul className="space-y-3 text-[16.5px] text-paper/80">
              {collections.map((c) => (
                <li key={c.id}>
                  <Link to={`/collections/${c.slug}`} className={item}>
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/?onSale=true" className={item}>
                  {t.common.reduced}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className={heading}>{t.footer.help}</p>
            <ul className="space-y-3 text-[16.5px] text-paper/80">
              {pages.map((p) => (
                <li key={p.slug}>
                  <Link to={`/pages/${p.slug}`} className={item}>
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
      <div className="container-page">
        <div className="flex flex-col gap-6 border-t border-paper/15 py-8 text-[14px] text-paper/55 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-1.5 md:flex-row md:gap-6">
            <span>
              © {year} {store.name}
            </span>
            {store.email && (
              <a href={`mailto:${store.email}`} className="link-underline hover:text-paper">
                {store.email}
              </a>
            )}
          </div>
          <div className="flex items-center gap-5">
            <LanguageSwitch className="[&_a[aria-current]]:bg-paper [&_a[aria-current]]:text-ink [&_a:not([aria-current])]:text-paper/60" />
          </div>
        </div>
      </div>
    </footer>
  );
}
